import React, { useState } from "react";
import styles from "./reset.module.css";
import FormFields from "../../components/Form";
import { useNavigate, useSearchParams } from "react-router-dom";
import Toast from "utils";
import axios from "axios";
import Button from "common/Button";

const ResetPassword = () => {

  const navigate = useNavigate()

  const [searchParams] = useSearchParams();

  const email = searchParams.get("email");
  const token = searchParams.get("token");



  const [resetPasswordDetails, setResetPasswordDetails] = useState({
    password: "",
    retypePassword: ""
  });

  const handleSubmit =  async(e) => {
    e.preventDefault();
    try {
      if(resetPasswordDetails?.password != resetPasswordDetails?.retypePassword){
        return Toast().Error("Passwords and Confirm Password Should Match");
      }
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/auth/reset-password`,
        {
          email,
          password:resetPasswordDetails?.password,
          confirm_password:resetPasswordDetails?.retypePassword
        },
        {
          headers: {
            Authorization: `Bearer ${token}` // Pass the token in the Authorization header
          }
        },
      );
      if (response?.data?.success) {
        // Toast().Success(response?.data?.message);
        Toast().Success("Please Login");
        navigate(`/`);
      }
    } catch (error) {
      Toast().Error(
        error?.response?.data?.message ||
          error?.response?.data?.errors?.[0]?.msg
      );
    }


  };

  const handleChange = (label) => {
    return (e) => {
      setResetPasswordDetails({ ...resetPasswordDetails, [label]: e.target.value });
    };
  }


  const Fields = [
    {
      label: "Password",
      id: "password",
      placeholder: "Enter Password",
      type: "password",
      value: resetPasswordDetails?.password,
      required: true,
      onChange: handleChange("password"),
    },
    {
      label: "Password",
      id: "retypePassword",
      placeholder: "ReType Password",
      type: "password",
      value: resetPasswordDetails?.retypePassword,
      required: true,
      onChange: handleChange("retypePassword"),
    }
  ];

 
  return (
    <div className={styles.container}>
      <h2 htmlFor="email" className={styles.signInLabel}>
        Sign in
      </h2>

      <div className={styles.formContainer}>
        <form onSubmit={handleSubmit}>
          <FormFields Fields={Fields} />
          <div className={styles.formGroup}>
            <Button type="submit"
             label={"Reset Password"}
                          buttonOverrideStyle={styles.button_}

            >
            </Button>
          </div>
        </form>
        <div className={styles?.divider}></div>
        <div className={styles.signup}>
          <div className={styles.signUpInfo}>
           Already have an account?
          </div>
          <button className={styles.registerButton} onClick={()=>navigate("/home")} >SignIn</button>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
